<!--<script src="../../../../packages/index.js"></script>-->
<template>

  <div style="height: 100%; overflow-y: hidden">
    <!--<fighter-dynamic-form :urlParams="urlParams"></fighter-dynamic-form>-->
    <!--//表单设计器页面，用于新增和编辑表单页面-->
    <!--<el-dialog :visible.sync="addVisible" :modal-append-to-body="false">-->
    <div v-if="addVisible" style="background-color: white;">
      <avue-form-design ref="avueformdesign" :options="options" @submit="handleSubmit">

      </avue-form-design>
    </div>

    <div v-if="formvisible" style="height: 100%; background-color: white; padding-top: 10px">
      <div class="drawer-top">
        <h1>{{options.tableComment}}</h1>
      </div>
      <avue-form ref="avueform" class="preview-form" :option="options" v-model="modeldata">

      </avue-form>
      <div class="drawer-foot">
        <el-button size="medium" type="primary" @click="handlePreviewSubmit">确定</el-button>
        <el-button size="medium" type="danger" @click="handleBeforeClose">取消</el-button>
      </div>
    </div>
    <transfer :transfer-info="transferConf.mainTable" @getModeData="setModeData"></transfer>
    <easy-crud v-if="tableVisible" ref="mainTable" :tableInfo="conf.mainTable" @mainTableReload="mainTableReload"
      @saveRowByAddOrEdit="saveRowByAddOrEdit" @beforeAddViewEdit="beforeAddViewEdit" @deleteRows="deleteRows">
    </easy-crud>
  </div>
</template>

<script>
//import dataTables from '@/components/baseComponent/dataTables/dataTables.vue'
//import localTable from '@/components/baseComponent/localTable/localTable.vue'
import transfer from '@/workFlow/formComponent/formTransfer/fromtransfer.vue'
import conf from './conf'
import transferConf from '../publicConfig/inputConf'
import { changeConfigToForm, modifyFormModelData, setMode, cascadeLocal, controlHideByCondition } from '@/workFlow/utils/formUtil'
import AvueFormDesign from '@/workFlow/formComponent/formDesigner/packages/index.vue'


export default {

  data() {
    return {
      addVisible: false,
      formvisible: false,
      tableVisible: true,
      full: true,
      modeldata: {},
      options: {

      },
      conf,
      transferConf
    }
  },

  components: { transfer, AvueFormDesign },
  watch: {
    modeldata: {
      handler(val) {
        if (this.options.jsPath && this.options.jsPath.endsWith('.js')) {
          changeWidgetFormData(val, this.options)
        }
        cascadeLocal(val, this.options, this.$http, this.$message)
        controlHideByCondition(val, this.options)
      },
      deep: true
    }
  },

  mounted: function (params) {
    this.$nextTick(() => {
      this.mainTableReload(this.$refs.mainTable.getReloadConditions())
    })
  },
  updated() {
    if (this.options.column && this.options.column.length > 0) {
      changeConfigToForm(document.getElementsByTagName('label'), this.options)
    }

  },


  methods: {
    handlePreviewSubmit() {//提交按钮的实现
      for (let key in this.modeldata) {
        console.log(key)
        console.log(typeof this.modeldata[key])
      }
      console.log(this.modeldata)
      console.log(JSON.stringify(this.modeldata))
    },
    setModeData(modeData) {
      setMode(modeData, this.options, this.modeldata, this.transferConf.mainTable)

      /*console.log(modeData)
      if(modeData instanceof Array){
          console.log('array')
          let idStr = [];
          let nameStr = [];
          for(let i = 0; i < modeData.length; i++){
              idStr.push(modeData[i].id + "")
              nameStr.push(modeData[i].fullName)
          }
          for(let i = 0; i < this.options.column.length; i++){
              if(this.options.column[i].prop === this.transferConf.mainTable.buttonSetting.modeConf.toLabel){
                  this.modeldata[this.options.column[i].prop] = idStr
              }
              if(this.options.column[i].type === 'input' && this.options.column[i].mode){
                  this.modeldata[this.options.column[i].prop] = nameStr
              }
          }
      }else{
          for(let i = 0; i < this.options.column.length; i++){
              if(this.options.column[i].prop === this.transferConf.mainTable.buttonSetting.modeConf.toLabel){
                  this.modeldata[this.options.column[i].prop] = modeData.id
              }
              if(this.options.column[i].type === 'input' && this.options.column[i].mode){
                  this.modeldata[this.options.column[i].prop] = modeData.fullName
              }
          }
      }*/
    },
    handleBeforeClose() {
      this.formvisible = false
      this.tableVisible = true
    },

    handleSubmit(val) {
      console.log(val);
    },
    /** 当主表需要重载的时候 */
    mainTableReload: function (params) {

      this.conf.mainTable.table.loading = true
      let JSONCon = {
        creator: params.creator,
        creatorName: params.creatorName,
        id: params.id,
        modelJson: params.modelJson,
        modelTable: params.modelTable,
        name: params.name,
        pageNum: params.pageNum,
        pageSize: params.pageSize,
        remark: params.remark,
        status: 1,
        templatePath: params.templatePath,
        updateTime: params.updateTime
      }
      if (this.$route && this.$route.query.name) {
        JSONCon.name = this.$route.query.name
      }
      this.$http.get('/form-model/query', { params: JSONCon }).then(
        response => {
          //console.log(response)
          this.conf.mainTable.table.loading = false
          if (response.code === 200) {
            // 成功之后的数据
            this.conf.mainTable.table.tableData = response.data.records
            this.conf.mainTable.table.paging.total = response.data.total || response.data.records.length
            return true
          } else {
            this.$message.error(response.msg)
          }
        }
      ).catch(
        error => {
          this.conf.mainTable.table.loading = false
          if (error.msg)
            this.$message.error(error.msg)
          else
            this.$message.error(error.message)
          this.$Log.capsule('分页加载模板错误', error, 'danger')
        }
      )

    },
    deleteRows: function (row) {//删除操作
      var params = new URLSearchParams()
      params.append("formId", row[0].id)
      this.$http.post('/form-model/delete?formId=' + row[0].id).then(res => {
        //this.conf.mainTable.loading = false
        if (res.code === 200) {
          this.$message.success('删除表单成功！')
          this.mainTableReload(this.$refs.mainTable.getReloadConditions())
        } else {
          this.$message.error(res.code + res.msg)
        }
      }).catch(error => {
        if (error.msg)
          this.$message.error(error.msg)
        else
          this.$message.error(error.message)
      })
    },
    saveRowByAddOrEdit: function (row, done, errorDone, optionType) {
      console.log(optionType)
    },
    beforeAddViewEdit: function name(row, optionType, call) {
      if (optionType === 'EDIT') {//编辑操作
        this.$http.get('form-model/detail', { params: { formId: row.id } }).then(response => {
          if (response.code === 200) {
            this.options = response.data.modelJson
            this.tableVisible = false
            this.addVisible = true
          } else {
            this.$message.error(response.code + response.msg)
          }

        }).catch(error => {
          if (error.msg)
            this.$message.error(error.msg)
          else
            this.$message.error(error.message)
        })

      } else if (optionType === 'ADD') {//新增操作
        this.options = {
          "column": [{//表单中默认添加的字段
            "type": "input",
            "label": "主表关键字",
            "span": 12,
            "display": false,
            "prop": "id",
            "maxlength": 32
          },
          {
            "type": "input",
            "label": "流程实例ID",
            "span": 12,
            "display": false,
            "prop": "processInstanceId",
            "maxlength": 64
          },
          {
            "type": "input",
            "label": "环节Id",
            "span": 12,
            "display": false,
            "prop": "taskId",
            "maxlength": 64
          },
          {
            "type": "input",
            "label": "创建人ID",
            "span": 12,
            "display": false,
            "prop": "creator",
            "maxlength": 32
          },
          {
            "type": "input",
            "label": "创建时间",
            "span": 12,
            "display": false,
            "prop": "createTime",
            "maxlength": 20
          },
          {
            "type": "input",
            "label": "最后修改人",
            "span": 12,
            "display": false,
            "prop": "lastUpdator",
            "maxlength": 32
          },
          {
            "type": "input",
            "label": "最后修改时间",
            "span": 24,
            "display": false,
            "prop": "lastUpdateTime",
            "maxlength": 20
          }
          ]
        }
        this.tableVisible = false
        this.addVisible = true
      } else {
        /*this.options = { "column": [{
                "type": "select",
                "label": "下拉选择器",
                "dicData": [
                    {
                        "label": "tongyi",
                        "value": 0
                    },
                    {
                        "label": "bohui",
                        "value": 1
                    },
                    {
                        "label": "butongyi",
                        "value": 2
                    }
                ],
                "span": 24,
                "display": true,
                "prop": "select"
            }
            ] }
        this.modeldata = { "select": '0'}
        this.tableVisible = false
        this.formvisible = true*/
        this.$http.get('/form-model/detail', { params: { 'formId': row.id } }).then(response => {
          if (response.code === 200) {
            let modelJson = response.data.modelJson
            modifyFormModelData(modelJson, this.transferConf)
            this.options = modelJson
            this.tableVisible = false
            this.formvisible = true
          } else {
            this.$message.error(response.code + response.msg)
          }
        }).catch(error => {
          if (error.msg)
            this.$message.error(error.msg)
          else
            this.$message.error(error.message)
        })
      }

    }
  }
}
</script>
<style lang="scss" scoped>
:deep(.drawer-foot) {
  position: absolute;
  /*bottom: 0;
        left: 0;
        right: 0;*/
  margin-top: 20px;
  //display: flex;

  button {
    width: 50%;
  }
}

.drawer-top {
  position: relative;
  height: 60px;
  text-align: center;
}

:deep(.preview-form) {
  padding-top: 10px;
  overflow-y: auto;
  height: 90%;
  padding-bottom: 50px;
}
:deep(.avue-crud) {
  padding-bottom: 18px;
}
</style>
